export default "__VITE_PUBLIC_ASSET__dd0af4c3__"